let getters = {
}

export default {
  namespaced: true,
  getters
}



// WEBPACK FOOTER //
// ./src/store/publicPage.js